import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { DownOutlined, RightOutlined, LoadingOutlined } from '@ant-design/icons';
import { Progress, Typography } from 'antd';
import { getColor, getSize } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Text = Typography.Text;
var dotsPulse = keyframes(["0%,100%{opacity:0;}50%{opacity:1;}"]);
var progressShimmer = keyframes(["0%{left:-100%;}100%{left:100%;}"]);
var DEFAULT_LABELS = {
  typing: 'Analyzing your request',
  processing: 'AI is under processing',
  complete: 'Processed',
  stopped: 'Stopped'
};
var ActionCard = styled.div.withConfig({
  displayName: "ai-processing-placeholdercontainer__ActionCard",
  componentId: "sc-zncefm-0"
})(["background:", ";border:1px solid #195aff;border-radius:12px;box-shadow:0 4px 12px rgba(25,90,255,0.1);max-width:460px;margin:16px 0;padding:16px;"], getColor('fillBgWhite'));
var Header = styled.div.withConfig({
  displayName: "ai-processing-placeholdercontainer__Header",
  componentId: "sc-zncefm-1"
})(["display:flex;align-items:center;gap:", ";margin-bottom:", ";"], getSize('gap16'), getSize('gap12'));
var SparkleIcon = styled.svg.withConfig({
  displayName: "ai-processing-placeholdercontainer__SparkleIcon",
  componentId: "sc-zncefm-2"
})(["flex-shrink:0;path{fill:#195aff;}"]);
var Title = styled(Text).withConfig({
  displayName: "ai-processing-placeholdercontainer__Title",
  componentId: "sc-zncefm-3"
})(["color:#195aff;font-weight:700;font-size:16px;"]);
var Description = styled(Text).withConfig({
  displayName: "ai-processing-placeholdercontainer__Description",
  componentId: "sc-zncefm-4"
})(["display:block;font-size:", ";margin-bottom:12px;color:", ";font-style:italic;line-height:1.6;"], getSize('typo14'), getColor('textIntSub'));
var AnimatedDots = styled.span.withConfig({
  displayName: "ai-processing-placeholdercontainer__AnimatedDots",
  componentId: "sc-zncefm-5"
})(["&::after{content:'...';animation:", " 1.5s infinite;}"], dotsPulse);
var StyledProgress = styled(Progress).withConfig({
  displayName: "ai-processing-placeholdercontainer__StyledProgress",
  componentId: "sc-zncefm-6"
})(["margin:0;line-height:1;.ant-progress-inner{background-color:", " !important;border-radius:100px !important;height:8px !important;overflow:hidden;}.ant-progress-bg{background:#195aff !important;height:8px !important;border-radius:100px !important;position:relative;overflow:hidden;&::after{content:'';position:absolute;top:0;width:100%;height:100%;background:linear-gradient( 90deg,rgba(255,255,255,0) 0%,rgba(255,255,255,0.4) 50%,rgba(255,255,255,0) 100% );animation:", " 2s infinite;}}"], getColor('fillHighlight3'), progressShimmer);
var StreamToggle = styled.button.withConfig({
  displayName: "ai-processing-placeholdercontainer__StreamToggle",
  componentId: "sc-zncefm-7"
})(["display:inline-flex;align-items:center;gap:6px;margin-top:10px;padding:0;border:none;background:transparent;color:#195aff;font-size:13px;font-weight:600;cursor:pointer;"]);
var StreamStatus = styled.span.withConfig({
  displayName: "ai-processing-placeholdercontainer__StreamStatus",
  componentId: "sc-zncefm-8"
})(["display:inline-flex;align-items:center;gap:6px;margin-left:8px;color:#195aff;font-size:12px;font-weight:500;"]);
var StreamPanel = styled.div.withConfig({
  displayName: "ai-processing-placeholdercontainer__StreamPanel",
  componentId: "sc-zncefm-9"
})(["margin-top:10px;padding:10px 12px;border-radius:10px;border:1px solid #d6e4ff;background:#f8fbff;max-height:180px;overflow-y:auto;white-space:pre-wrap;word-break:break-word;font-size:13px;line-height:1.5;color:#434343;"]);
var Cursor = styled.span.withConfig({
  displayName: "ai-processing-placeholdercontainer__Cursor",
  componentId: "sc-zncefm-10"
})(["display:inline-block;width:2px;height:14px;background-color:#195aff;margin-left:2px;animation:", " 1s infinite;vertical-align:middle;"], dotsPulse);
export var AiProcessingPlaceholder = function AiProcessingPlaceholder(_ref) {
  var _ref$isTyping = _ref.isTyping,
      isTyping = _ref$isTyping === void 0 ? false : _ref$isTyping,
      _ref$isProcessing = _ref.isProcessing,
      isProcessing = _ref$isProcessing === void 0 ? false : _ref$isProcessing,
      _ref$isStoppedByUser = _ref.isStoppedByUser,
      isStoppedByUser = _ref$isStoppedByUser === void 0 ? false : _ref$isStoppedByUser,
      _ref$isComplete = _ref.isComplete,
      isComplete = _ref$isComplete === void 0 ? false : _ref$isComplete,
      _ref$labels = _ref.labels,
      labels = _ref$labels === void 0 ? {} : _ref$labels,
      _ref$autoHideDelay = _ref.autoHideDelay,
      autoHideDelay = _ref$autoHideDelay === void 0 ? 3000 : _ref$autoHideDelay,
      stopMessage = _ref.stopMessage,
      _ref$streamDataConten = _ref.streamDataContent,
      streamDataContent = _ref$streamDataConten === void 0 ? '' : _ref$streamDataConten,
      _ref$isDataStreaming = _ref.isDataStreaming,
      isDataStreaming = _ref$isDataStreaming === void 0 ? false : _ref$isDataStreaming;

  var mergedLabels = _objectSpread(_objectSpread({}, DEFAULT_LABELS), labels);

  var _useState = useState(0),
      progress = _useState[0],
      setProgress = _useState[1];

  var _useState2 = useState(false),
      showCard = _useState2[0],
      setShowCard = _useState2[1];

  var _useState3 = useState(false),
      isOpen = _useState3[0],
      setIsOpen = _useState3[1];

  var intervalRef = useRef(null);
  var streamPanelRef = useRef(null);
  var phase = useMemo(function () {
    if (isStoppedByUser) return 'stopped';
    if (isComplete) return 'complete';
    if (isProcessing) return 'processing';
    if (isTyping) return 'typing';
    return 'idle';
  }, [isStoppedByUser, isComplete, isProcessing, isTyping]);
  var hasStreamData = streamDataContent.length > 0;
  useEffect(function () {
    if (phase !== 'idle') {
      setShowCard(true);
    }
  }, [phase]);
  useEffect(function () {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    switch (phase) {
      case 'typing':
        setProgress(0);
        intervalRef.current = setInterval(function () {
          setProgress(function (prev) {
            if (prev < 25) return prev + 1.5;
            if (prev < 30) return prev + 0.3;
            return prev;
          });
        }, 150);
        break;

      case 'processing':
        intervalRef.current = setInterval(function () {
          setProgress(function (prev) {
            if (prev < 85) return prev + 2;
            return prev;
          });
        }, 100);
        break;

      case 'complete':
        intervalRef.current = setInterval(function () {
          setProgress(function (prev) {
            if (prev < 100) return prev + 1;
            return prev;
          });
        }, 50);
        break;

      case 'stopped':
        {
          var hideTimer = setTimeout(function () {
            setShowCard(false);
            setProgress(0);
            setIsOpen(false);
          }, autoHideDelay);
          return function () {
            return clearTimeout(hideTimer);
          };
        }

      case 'idle':
      default:
        setProgress(0);
        setShowCard(false);
        setIsOpen(false);
        break;
    }

    return function () {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [phase, autoHideDelay]);
  useEffect(function () {
    if (!isOpen || !streamPanelRef.current) return;
    streamPanelRef.current.scrollTop = streamPanelRef.current.scrollHeight;
  }, [isOpen, streamDataContent, isDataStreaming]);
  if (!showCard) return null;

  var description = function () {
    switch (phase) {
      case 'typing':
        return /*#__PURE__*/_jsxs(Description, {
          children: [mergedLabels.typing, /*#__PURE__*/_jsx(AnimatedDots, {})]
        });

      case 'processing':
        return /*#__PURE__*/_jsxs(Description, {
          children: [mergedLabels.processing, /*#__PURE__*/_jsx(AnimatedDots, {})]
        });

      case 'complete':
        return /*#__PURE__*/_jsx(Description, {
          children: mergedLabels.complete
        });

      case 'stopped':
        return /*#__PURE__*/_jsx(Description, {
          children: stopMessage || mergedLabels.stopped
        });

      default:
        return null;
    }
  }();

  return /*#__PURE__*/_jsxs(ActionCard, {
    children: [/*#__PURE__*/_jsxs(Header, {
      children: [/*#__PURE__*/_jsx(SparkleIcon, {
        width: "20",
        height: "20",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/_jsx("path", {
          d: "M8 0L9.8 6.2L16 8L9.8 9.8L8 16L6.2 9.8L0 8L6.2 6.2L8 0Z"
        })
      }), /*#__PURE__*/_jsx(Title, {
        children: "AI Action"
      })]
    }), description, phase !== 'stopped' && /*#__PURE__*/_jsx(StyledProgress, {
      percent: Math.floor(progress),
      showInfo: true,
      size: "small",
      status: phase === 'complete' ? 'success' : 'active'
    }), (hasStreamData || isDataStreaming) && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(StreamToggle, {
        type: "button",
        onClick: function onClick() {
          return setIsOpen(function (prev) {
            return !prev;
          });
        },
        children: [isOpen ? /*#__PURE__*/_jsx(DownOutlined, {}) : /*#__PURE__*/_jsx(RightOutlined, {}), /*#__PURE__*/_jsx("span", {
          children: "View details"
        }), isDataStreaming && /*#__PURE__*/_jsxs(StreamStatus, {
          children: [/*#__PURE__*/_jsx(LoadingOutlined, {}), /*#__PURE__*/_jsx("span", {
            children: "Streaming"
          })]
        })]
      }), isOpen && /*#__PURE__*/_jsxs(StreamPanel, {
        ref: streamPanelRef,
        children: [streamDataContent, isDataStreaming && /*#__PURE__*/_jsx(Cursor, {})]
      })]
    })]
  });
};